import { IGetChecklistServicosDropDownUseCase } from "../../../presentation/useCases/read/get_checklist_servicos_drop_down_use_case";
import { ChecklistServicoDropDown } from "../../models/checklist_servico_dropdown";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetChecklistServicosDropDownUseCase
 */

export class GetChecklistServicosDropDownUseCase implements IGetChecklistServicosDropDownUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async getChecklistServicosDropDown(
  ): Promise<ChecklistServicoDropDown[]> {
    return this.repository.getChecklistServicosDropDown();
  }
}
